import { ThemeProvider, type SupportedColorScheme } from '@mui/material/styles'
import type { FC } from 'react'
import React from 'react'
import { createTheme } from './create-theme.js'

export interface TunaThemeProps {
  colorScheme?: SupportedColorScheme
  /** @default 14 */
  textSize?: number
  children?: React.ReactNode
}

export const TunaTheme: FC<TunaThemeProps> = ({ colorScheme, children, textSize = 14 }) => {
  const muiTheme = createTheme({ textSize })

  // Explicitly turn off the storage manager if colorScheme is provided
  const storageManager = colorScheme ? null : undefined

  return (
    <ThemeProvider theme={muiTheme} defaultMode={colorScheme} storageManager={storageManager}>
      {children}
    </ThemeProvider>
  )
}
